<template>
  <div v-if="record !== undefined">
    <div class="col-lg-24 col-md-24 col-sm-24 col-xs-24" @click="dateSelected"><span class="roundedCircle" :style="buttonStyles">{{record.Day}}/{{record.Month}}</span></div>
    <div class="col-lg-24 col-md-24 col-sm-24 col-xs-24" @click="dateSelected"><span class="roundedCircleMsg">{{record.DayName}}</span></div>
  </div>
</template>

<style>
.roundedCircle
{
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #111111;
    color: #fff;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    -webkit-transition: all 0.4s ease-out;
    -moz-transition: all 0.4s ease-out;
    -o-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
    cursor: pointer;
}
.roundedCircleMsg
{
    width: 40px;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
}
.col-xs-12 > .roundedCircle
{
    width: 30px;
    height: 30px;
    line-height: 30px;
}
.col-xs-12 > .roundedCircleMsg
{
    width: 30px;
    height: 30px;
    line-height: 30px;
}
.inactivepast
{
  background: repeating-linear-gradient(
  135deg,
  #aaa,
  #666 5px,
  #aaa 5px,
  #aaa 5px
);
}
</style>

<script>
  import Vue from 'vue';

  export default {
    props: ['record'],
    data () {
      return {
         
      }
    },
    methods: {
      dateSelected (id) {
          this.record.IsSelected = true;
          this.$emit('dat-select-event', this.record);
      }
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       },
      buttonStyles(){
        return {
            backgroundColor : this.record.IsSelected ? Vue.$storeSettings.ColorApp  : "#ddd",
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cart/SingleSalonCartDateItem.vue